import { TADManager } from "tad-core";
import { Shark, Utils } from "shark-mvc";
import "Models/Vehicle";

var vehicleManager = Shark.createJaw("vehicleManager");

vehicleManager.addMethod("getList", function () {
	TADManager.clearCollection();
	TADManager.createTAD({ t: "vehicle", a: "getList" });

	TADManager.sendDefaultCollection(function (response) {
		var responseTAD = response.getItem(0);

		console.log({ where: "vehicleManager > getList > apiResponse", response: response, responseTAD: responseTAD });

		switch (responseTAD.checkResponseStatus()) {
			case "ok":
				Shark.set({
					vehicleList: Shark.getInstanceList("Vehicle", responseTAD.responseData[0].data),
					vehicleTotalLength: responseTAD.responseData[0].total
				});

				vehicleManager.emit("listChanged");

				break;
			case "ko":
				vehicleManager.emit("getListError", responseTAD.lastErrorMessage);
				break;
		}
	});
});

Shark.registerController(vehicleManager);

export { vehicleManager };